interface LocaleDescription {
  description?: string;
  chineseDescription?: string;
}

interface LocaleName {
  name?: string;
  chineseName?: string;
}

/**
 * @param isEnglish
 * @return function has description and chinese description
 * @description get description following isEnglish param, if there is no chinese description, it will get english description.
 */
export function getLocaleDescription(isEnglish: boolean) {
  return ({ description, chineseDescription }: LocaleDescription): string => {
    const localeDescription = isEnglish ? description : chineseDescription;
    return localeDescription ? localeDescription : description || '';
  };
}

/**
 * @param isEnglish
 * @return function has name and chinese name
 * @description get name following isEnglish param, if there is no chinese name, it will get english name.
 */
export function getLocaleName(isEnglish: boolean) {
  return ({ name, chineseName }: LocaleName): string => {
    const localeName = isEnglish ? name : chineseName;
    return localeName ? localeName : name || '';
  };
}
